import * as React from "react";

import styles from "./PlayIcon.module.css";

export default function PlayIcon() {
  return (
    <div className={styles.playIcon} data-component="play-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        className={styles.rightTriangle}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3635 8.99987L6.09082 13.3635L6.09082 4.63623L13.3635 8.99987Z"
          fill="white"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={styles.circle}
      >
        <circle
          cx="12"
          cy="12"
          r="11"
          fill="black"
          fillOpacity="0.3"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
}
